import { Injectable } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { SendClaimMessageRequest } from '@app/communications/models/requests/send-claim-message-request';
import { ClaimSmsForm } from '@app/communications/models/forms/claim-sms-form';
import { MessageTypeEnum } from '@app/communications/models/enums/message-type.enum';
import { AutoUnsubscription } from '@app/shared/helpers/observable-helpers';
import { takeUntil } from 'rxjs/operators';

@Injectable()
export class ClaimSmsModalFormService extends AutoUnsubscription {
  form: FormGroup<ClaimSmsForm>;
  maxSmsLength = 160;

  constructor(private formBuilder: FormBuilder) {
    super();

    this.form = this.formBuilder.group<ClaimSmsForm>({
      claimContact: new FormControl<number>(null, Validators.required),
      sender: new FormControl<number>(null, Validators.required),
      message: new FormControl<string>(null, [
        Validators.maxLength(this.maxSmsLength),
        Validators.required,
      ]),
      messageType: new FormControl<MessageTypeEnum>(null, Validators.required),
    });
    this.form.controls.message.disable();

    this.form.controls.messageType.valueChanges
      .pipe(takeUntil(this.notifier))
      .subscribe((messageType) => {
        if (messageType == MessageTypeEnum.CustomSMS) {
          this.form.controls.message.enable();
          this.form.controls.message.patchValue('');
        } else {
          this.form.controls.message.disable();
        }
      });
  }

  populateRequestModelFromForm(
    claimCode: string,
    conversationId: number,
  ): SendClaimMessageRequest {
    const formValues = this.form.getRawValue();
    return {
      claimsContactId: formValues.claimContact,
      systemContactId: formValues.sender,
      claimCode,
      messageType: formValues.messageType,
      message: formValues.message,
      conversationId,
    };
  }

  clear() {
    this.form.controls.messageType.setValue(null);
    this.form.controls.claimContact.setValue(null);
    this.form.controls.sender.setValue(null);
  }

  patchSender(sender: number) {
    this.form.controls.sender.patchValue(sender);
  }

  patchClaimContact(claimContact: number) {
    this.form.controls.claimContact.patchValue(claimContact);
  }

  patchMessage(messagePreview: string) {
    this.form.controls.message.patchValue(messagePreview);
  }
}
